import { SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { IContentInfo } from '~src/ts/models/IContentInfo';

import { Messages } from '../../../codegen/Localize';
import { getContentSpaceDefinition } from '../../../contentDefinitionInterfaces/ContentDefinitionsLists';
import { getPathFromUrl } from '../../../ts/helpers/UrlHelpers';
import {
  INamedItemInfo,
  ISpaceTypeInfo
} from '../../../ts/models/resourceInfoParts';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { getAppStore } from '../../AppStore';
import { addQuery, SpacesSiteUrls } from '../../spaces/SpacesSiteUrls';
import { BreadcrumbStateInfo } from './BreadcrumbStateInfo';

export function populateContentBreadcrumbs(contentPath: ISpaceTypeInfo[], siteUrls: SpacesSiteUrls) {
  if (!siteUrls) {
    return;
  }

  let rootHref = addQuery(siteUrls.exploreUrl());

  const rootBreadcrumb: BreadcrumbStateInfo = getRootBreadcrumb(rootHref, Messages.explore());

  const contentBreadcrumbs: BreadcrumbStateInfo[] =getContentBreadcrumb(siteUrls, contentPath);

  getAppStore().dispatch(updateBreadcrumbs([].concat(rootBreadcrumb).concat(contentBreadcrumbs)));
}

export function populateBreadcrumbsForPS(contents: ISpaceTypeInfo[], siteUrls: SpacesSiteUrls) {
  if (!siteUrls) {
    return;
  }

  const content = contents[0] as IContentInfo;
  const ownerId = content.owner.id;
  const currentUserId = SessionUserSelectors.sessionUserId(getAppStore().getState());
  let rootHref = (ownerId === currentUserId)? addQuery(siteUrls.personalSpaceUrl()) : null;

  const rootBreadcrumb: BreadcrumbStateInfo = getRootBreadcrumb(rootHref, Messages.navigation_personalSpace());

  const contentBreadcrumbs: BreadcrumbStateInfo[] = getContentBreadcrumb(siteUrls, contents);
  getAppStore().dispatch(updateBreadcrumbs([].concat(rootBreadcrumb).concat(contentBreadcrumbs)));
}

export function addContentTypeToProjectHierarchy(projectHierarchy: INamedItemInfo[]): ISpaceTypeInfo<'project'>[] {
  if (!projectHierarchy){
    return [];
  }

  return projectHierarchy.map(project => {
    const ret: ISpaceTypeInfo<'project'> = {
      ...project,
      contentType: 'project'
    };
    return ret;
  });
}

function getRootBreadcrumb(rootHref: string, message: string): BreadcrumbStateInfo {
  return {
    id: getPathFromUrl(rootHref),
    text: message,
    href: rootHref,
    testId: 'breadcrumb-content-root'
  };
}

function getContentBreadcrumb(siteUrls: SpacesSiteUrls, contentPath: ISpaceTypeInfo[]): BreadcrumbStateInfo[] {
  return (contentPath.map(item => {
    const href = getContentSpaceDefinition(item.contentType).contentSpaceUrl(siteUrls, item.id, '');
    return {
      id: getPathFromUrl(href),
      text: item.name,
      href: href,
      testId: `breadcrumb-${item.contentType}-${item.id}`
    };
  }));
}
